import { defineStore } from "pinia";
import {
  toDataURL,
  type WorkbookOptions,
} from "@progress/kendo-vue-excel-export";
import { initializeColumns } from "@/shared/helpers/exportHelper";

export const useExportStore = defineStore("scheduleA", {
  state: () => {
    return {
      options: null as WorkbookOptions | null,
      subscribers: [] as {
        callback: (data: WorkbookOptions | null) => void;
        priority: number;
      }[],
    };
  },
  actions: {
    exportExcel(fileName: string, options: WorkbookOptions | null = null) {
      this.options = options;

      this.subscribers
        .sort((a, b) => b.priority - a.priority)
        .forEach((s) => s.callback(this.options));

      if (this.options) {
        //initializeColumns(this.options);
        toDataURL(this.options).then((dataUrl) => {
          const link = document.createElement("a");
          link.download = fileName;
          link.href = dataUrl;
          link.click();
        });
      }
    },
    subscribe(
      callback: (data: WorkbookOptions | null) => void,
      priority: number = 0
    ) {
      this.subscribers.push({ callback, priority });
    },
  },
});
